import { render, staticRenderFns } from "./MRC_ESS_noContent.vue?vue&type=template&id=86957906&"
import script from "./MRC_ESS_noContent.vue?vue&type=script&lang=js&"
export * from "./MRC_ESS_noContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VContainer,VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86957906')) {
      api.createRecord('86957906', component.options)
    } else {
      api.reload('86957906', component.options)
    }
    module.hot.accept("./MRC_ESS_noContent.vue?vue&type=template&id=86957906&", function () {
      api.rerender('86957906', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MRC_ESS_noContent.vue"
export default component.exports